// *** Reset Password Component ****
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import Validation from "../../commonComponents/Validation";
import PasswordReset from "../../commonComponents/PasswordReset";

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
     const data = location.state || {};
    const [token, setToken] = useState('');
    const [password, setPassword] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    
    return (
        <div>
             <PasswordReset
            image="reset"
            title="Change Password"
             content=""
             userid={data.userId}
            />
        </div>
    );
};
export default ResetPassword;

